module.exports=function(scope){ return `var https = require("https");

callFaceTecAPI("/api/v2/biometrics/session-token", function(error, result) {
  if(error) {
    console.log("Error:" + error);
  }
  else if(result) {
    console.log(result)
  }
})

function callFaceTecAPI(path, callback){
  var options = {
    hostname: "api.zoomauth.com",
    port: 443,
    path: path,
    method: "GET",
    headers: {
        "Content-Type": "application/json",
        "X-Device-License-Key": "${scope.appToken}"
    }
  }

  var req = https.request(options, (res) => {
      var output = ""

      res.on("data", (d) => {
          output += d
      })

      res.on("end", () => {
        try{
          var obj = JSON.parse(output)
          callback(undefined, obj)
        }
        catch(error) {
          callback(error, undefined)
        }
      })
  })

  req.on("error", (error) => {
    callback(error, undefined)
  })

  req.end()
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/webservice-v2/nodejs/session-token.js.tpl